export const USER = {
  GET_ME: 'users/me'
}

export const USER_QUERY_KEYS = {
  GET_ME: ['user', 'me']
}

export const WORKSPACE = {
  GET_ALL: 'workSpaces'
}

export const WORKSPACE_QUERY_KEYS = {
  GET_ALL: ['workspaces', 'workspace-plan', 'current-workspace']
}

export const BILLING = {
  GET_PLAN: workspaceId => `billing/get-plan-info/${workspaceId}`
}

export const BILLING_QUERY_KEYS = {
  GET_PLAN: workspaceId => ['billing', 'plan', 'info', workspaceId]
}

export const INTERCOM = {
  GET_CUSTOM_ATTRIBUTES: 'intercom/get-attributes'
}

export const INTERCOM_QUERY_KEYS = {
  GET_CUSTOM_ATTRIBUTES: ['intercom', 'attributes']
}

export const PARTNER = {
  GET_PARTNER: 'branding-management/theme'
}

export const PARTNER_QUERY_KEYS = {
  GET_PARTNER: ['partner', 'details']
}

export const WHITE_LABEL_TEAM = {
  GET_USER_PERMISSION: 'team-management/member/user-permissions'
}

export const WHITE_LABEL_TEAM_QUERY_KEYS = {
  GET_USER_PERMISSION: ['team-management', 'member', 'user-permissions']
}
